// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1g6r5","label":"Category_label__2-bTs","content":"Category_content__3Q2UB","header":"Category_header__38rYE","location":"Category_location__1G31M"};